// extracted by mini-css-extract-plugin
export default {"login":"Contact_login__gT-ru","form":"Contact_form__ns3UO","submitButton":"Contact_submitButton__nRK-B"};